import OrdersPage from './OrdersPage';

export default OrdersPage;


// WEBPACK FOOTER //
// ./src/components/OrdersPage/index.jsx